var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40.003,
    viewBox: "0 0 40 40.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.004 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40-64.522,29.351-75.174A15.917,15.917,0,0,0,32-84a16,16,0,0,0-16-16A16,16,0,0,0,0-84,16,16,0,0,0,16-68a15.932,15.932,0,0,0,8.824-2.653L35.479-60ZM4.537-84A11.465,11.465,0,0,1,16-95.46,11.466,11.466,0,0,1,27.472-84,11.469,11.469,0,0,1,16-72.527,11.468,11.468,0,0,1,4.537-84Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.c8f8795627bbd8bd0ffc57a8f2a4b84d.svg";
export { ForwardRef as ReactComponent };